import InvoicingSettings from './InvoicingSettings';

export default InvoicingSettings;


// WEBPACK FOOTER //
// ./src/scenes/OrderView/OrderView/InvoicingSettings/index.tsx